import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CardService } from '../../services/card.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstantsKey } from "app/shared/constant/constants-keys";

@Component({
  selector: 'buy-international-esim',
  templateUrl: './buy-international-esim.component.html',
  styleUrls: ['./buy-international-esim.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BuyInternationalEsimComponent implements OnInit {
    public showLoader: boolean = false;
    showFreePlanCard: boolean = false;
    planData: any;
    public displayCount: number = 14;
    showDropdown = false;
    selectedCountry: string = '';
    selectedCountryIcon: string = '';
    selectedDuration: string | null = null;
    isDurationSelected = false; 
    public searchCountryName = "";
    public filteredCountry:any =  [];
    public eSimPackeges:any = [];
    public selectedPlan: any;
    public orderType;
    public isCountrySelected = false;
    durationOptions = [{title:"1-7 days", value: '1-7'}, {title:"7-15 days", value: '7-15'}, {title:"15-30 days", value: '15-30'}, {title:"More than 30 days", value: '30+'}];
    public orderData: any;
    activeTab = 'iosDevices';
   
    @ViewChild('devicesModal') devicesModal: any;

    public countryItems = [
      {
        'icon': 'aus.png',
        'title': 'Australia',
        'url': '',
        'countryCode': 'AU',
        'flag': 'aud.png'
      },
      {
        'icon': 'azer.png',
        'title': 'Azerbaijan',
        'url': '',
        'countryCode': 'AZ',
        'flag': ''
      },
      {
        'icon': 'cad.png',
        'title': 'Canada',
        'url': '',
        'countryCode': 'CA',
        'flag': 'cad.png'
      },
      {
        'icon': 'china.png',
        'title': 'China',
        'url': '',
        'countryCode': 'CN',
        'flag': 'china.png'
      },
      {
        'icon': 'dubai.png',
        'title': 'Dubai',
        'url': '',
        'countryCode': 'AE',
        'flag': 'dubai.png'
      },
      {
        'icon': 'france.png',
        'title': 'France',
        'url': '',
        'countryCode': 'FR',
        'flag': 'usd.png'
      },
      {
        'icon': 'germany.png',
        'title': 'Germany',
        'url': '',
        'countryCode': 'DE',
        'flag': 'usd.png'
      },
      {
        'icon': 'hongkong.png',
        'title': 'Macao China',
        'url': '',
        'countryCode': 'MO',
        'flag': ''
      },
      
      {
        'icon': 'Indonesia.png',
        'title': 'Indonesia',
        'url': '',
        'countryCode': 'ID',
        'flag': ''
      },
      {
        'icon': 'ireland.png',
        'title': 'Ireland',
        'url': '',
        'countryCode': 'IE',
        'flag': 'ireland.png'
      },
      {
        'icon': 'italy.png',
        'title': 'Italy',
        'url': '',
        'countryCode': 'IT',
        'flag': ''
      },
      {
        'icon': 'japan.png',
        'title': 'Japan',
        'url': '',
        'countryCode': 'JP',
        'flag': ''
      },
      {
        'icon': 'malaysia.png',
        'title': 'Malaysia',
        'url': '',
        'countryCode': 'ML',
        'flag': 'malaysia.png'
      },
      {
        'icon': 'netherlands.png',
        'title': 'Netherlands',
        'url': '',
        'countryCode': 'NL',
        'flag': ''
      },
      {
        'icon': 'newzea.png',
        'title': 'New Zealand',
        'url': '',
        'countryCode': 'NZ',
        'flag': ''
      },
      
      {
        'icon': 'portugal.png',
        'title': 'Portugal',
        'url': '',
        'countryCode': 'PT',
        'flag': ''
      },
      {
        'icon': 'saudi-arabia.png',
        'title': 'Saudi Arabia',
        'url': '',
        'countryCode': 'SA',
        'flag': ''
      },
      {
        'icon': 'singapore.png',
        'title': 'Singapore',
        'url': '',
        'countryCode': 'SG',
        'flag': 'usd.png'
      },
      {
        'icon': 'spain.png',
        'title': 'Spain',
        'url': '',
        'countryCode': 'ES',
        'flag': ''
      },
      {
        'icon': 'srilanka.png',
        'title': 'Srilanka',
        'url': '',
        'countryCode': 'LK',
        'flag': ''
      }, 
      {
        'icon': 'switzerland.png',
        'title': 'Switzerland',
        'url': '',
        'countryCode': 'CH',
        'flag': ''
      },
      {
        'icon': 'thailand.png',
        'title': 'Thailand',
        'url': '',
        'countryCode': 'US',
        'flag': 'usd.png'
      },
      {
        'icon': 'turkey.png',
        'title': 'Turkey',
        'url': '',
        'countryCode': 'TR',
        'flag': ''
      },
      {
        'icon': 'uae.png',
        'title': 'UAE',
        'url': '',
        'countryCode': 'AE',
        'flag': 'uae.png'
      },
      {
        'icon': 'uk.png',
        'title': 'United Kingdom',
        'url': '',
        'countryCode': 'GB',
        'flag': 'gbp.png'
      },
      {
        'icon': 'usa.png',
        'title': 'USA',
        'url': '',
        'countryCode': 'US',
        'flag': 'usd.png'
      },
      
      {
        'icon': 'vietnam.png',
        'title': 'Vietnam',
        'url': '',
        'countryCode': 'VN',
        'flag': 'vietnam.png'
      },
     
      
      
     
      
      
      
     
    
         
    ];
    public claimCoutryItems = [
      {
        'icon': 'usa.png',
        'title': 'USA',
        'url': '',
        'countryCode': 'US',
        'flag': 'usd.png'
      },
      {
        'icon': 'cad.png',
        'title': 'Canada',
        'url': '',
        'countryCode': 'CA',
        'flag': 'cad.png'
      },
      {
        'icon': 'aus.png',
        'title': 'Australia',
        'url': '',
        'countryCode': 'AU',
        'flag': 'aud.png'
      },
      {
        'icon': 'uk.png',
        'title': 'United Kingdom',
        'url': '',
        'countryCode': 'GB',
        'flag': 'gbp.png'
      },
      {
        'icon': 'germany.png',
        'title': 'Germany',
        'url': '',
        'countryCode': 'DE',
        'flag': 'usd.png'
      },
      {
        'icon': 'france.png',
        'title': 'France',
        'url': '',
        'countryCode': 'FR',
        'flag': 'usd.png'
      },
      {
        'icon': 'newzea.png',
        'title': 'New Zealand',
        'url': '',
        'countryCode': 'NZ',
        'flag': ''
      }];
    iosItems: string[] = [


      'iPhone 16, 16 Plus, 16 Pro, 16 Pro Max',
      
      'iPhone 15, Plus, Pro, Pro Max',
      
      'iPhone 14, Pro, Pro Max, Plus',
      
      'iPhone 13, Mini, Pro, Pro Max',
      
      'iPhone 12, Mini, Pro, Pro Max',
      
      'iPhone 11, Pro, Pro Max',
      
      'iPhone XS, XS Max, XR',
      
      'iPhone SE (2020, 2022)'
      
      ];
      
       
      
      androidItems: string[] = [
      
      'Galaxy S23, S23+, S23 Ultra',
      
      'Galaxy S22, S22+, S22 Ultra',
      
      'Galaxy S21, S21+, S21 Ultra, 5G',
      
      'Galaxy S20, S20+, S20+ 5G, S20 Ultra 5G, S20 Ultra',
      
      'Galaxy Note 20',
      
      'Galaxy Z',
      
      'Galaxy Note 20 Ultra',
      
      'Galaxy A54 5G',
      
      'Pixel 2, 2 XL',
      
      'Pixel 3, 3 XL, 3a, 3a XL',
      
      'Pixel 4, 4a, 4 XL',
      
      'Pixel 5, 5a',
      
      'Pixel 6, 6a, 6 Pro',
      
      'Pixel 7, 7a, 7 Pro',
      
      'Pixel 8, 8 Pro',
      
      'Pixel Fold',
      
      'OPPO Find X3 Pro',
      
      'OPPO Find N2 Flip',
      
      'OPPO Reno 5A',
      
      'OPPO Reno 6 Pro 5G',
      
      'OPPO Reno 9A',
      
      'OPPO Find X5, Find X5 Pro',
      
      'OPPO A55s 5G',
      
      'Sony Xperia 10 III Lite',
      
      'Sony Xperia 10 IV',
      
      'Xperia 10V',
      
      'Xperia 1 IV',
      
      'Sony Xperia 5 IV',
      
      'Sony Xperia 1 V',
      
      'Sony Xperia Ace III',
      
      'Sony Xperia 5 V',
      
      'Xiaomi 12T Pro',
      
      'Xiaomi 13, 13 Lite, 13 Pro, 13T Pro',
      
      'Huawei P40, P40 Pro',
      
      'Huawei Mate 40 Pro',
      
      'Huawei Mate Xs, Xs2',
      
      'Huawei P70, P70 Pro and P70 Art',
      
      'Motorola Razr 2019, Razr 5G',
      
      'Motorola Razr 40, Razr 40 Ultra',
      
      'Motorola Razr+',
      
      'Motorola Edge+',
      
      'Motorola Edge 40, Edge 40 Pro, Edge 40 Neo',
      
      'Motorola G52J 5G',
      
      'Motorola G52J 5G Ⅱ',
      
      'Motorola G53J 5G',
      
      'Moto G54 5G',
      
      'Motorola G84',
      
      'Samsung Galaxy S24, S24 Plus, S24 Ultra, S24 FE',
      
      'Samsung Galaxy Fold',
      
      'Samsung Galaxy Z Fold2 5G',
      
      'Samsung Galaxy Z Fold3 5G',
      
      'Samsung Galaxy Z Fold4',
      
      'Samsung Galaxy Z Fold5 5G',
      
      'Samsung Galaxy Z Fold6 5G',
      
      'Samsung Galaxy Z Flip',
      
      'Samsung Galaxy Z Flip3 5G',
      
      'Samsung Galaxy Z Flip4',
      
      'Samsung Galaxy Z Flip5 5G',
      
      'Samsung Galaxy Z Flip6 5G',
      
      'Samsung Galaxy A55 5G',
      
      'Samsung Galaxy A35',
      
      'Google Pixel 9, 9 Pro, 9 Pro XL',
      
      'Oppo Find X3, X8, X8 Pro',
      
      'Oppo Find N3, N3 Flip',
      
      'Xiaomi 14, 14 Pro, 14T, 14T Pro',
      
      'Xiaomi Redmi Note 13 Pro+',
      
      'Motorola Edge 2022, Edge 2023, Edge+ 2023',
      
      'Motorola Edge 50 Pro, Ultra, Fusion',
      
      'Motorola Moto G Power 5G',
      
      'Motorola G34',
      
      'Motorola Razr 2024, Razr+ 2024',
      
      'Motorola Moto G Stylus 5G 2024',
      
      'Honor Magic 4 Pro, 5 Pro, 6 Pro',
      
      'Honor 90',
      
      'Honor X8',
      
      'Honor 200, 200 Pro',
      
      'Honor Magic V2, V3',
      
      'OnePlus 11, 12 ,13',
      
      'Nokia XR21, X30, g60',
      
      'Vivo X80 Pro, X90 pro, X100 Pro',
      
      'Vivo V29, V29 Lite, V29 Lite 5G',
      
      'Vivo V40, V40 Lite, V40 SE',
      
      'OUKITEL WP30 Pro, WP33 Pro',
      
      'Nuu X5',
      
      'ZTE Nubia Flip',
      
      'TLC 50 5G',
      
      'Asus ROG Phone 9, 9 Pro',
      
      'HAMMER Blade 3, 5G',
      
      'HAMMER Explorer PRO',
      
      'Gemini PDA',
      
      'Fairphone 4, 5',
      
      'DOOGEE V30',
      
      'Sharp AQUOS sense4 lite, Sense6s, sense 7, sense 7plus',
      
      'Sharp AQUOS Wish, Wish 2, wish 3',
      
      'AQUOS zero 6',
      
      'Simple Sumaho6',
      
      'Sharp AQUOS R7, R8, R8 Pro',
      
      'Rakuten Mini',
      
      'Rakuten Big, Big-S',
      
      'Rakuten Hand, Hand 5G'
      
      ];
      
       
      setActiveTab(tabName: string) {
        this.activeTab = tabName;
      }
    
    constructor(
      public router: Router,
      public cardService: CardService, 
      public toast: ToastrService,
      private modalService: NgbModal

    ) { }
  
    ngOnInit() {
      this.getProfileList();
      this.orderData = JSON.parse(sessionStorage.getItem(ConstantsKey.ADD_ON_ORDER_TYPE));
      this.orderType = this.orderData.orderType;
      if(this.orderType == "BUY") {
        this.filteredCountry = this.countryItems;      
      } else if(this.orderType == "CLAIM") {
        this.filteredCountry = this.claimCoutryItems;
      }


    }
  
    getProfileList() {
     
    }

    showFreePlan(singleItem: any) {
       
        this.showFreePlanCard = true;
    }
  
   
  
    proceedToNextPage(pageUrl) {
      this.router.navigate([pageUrl]);
    }

    countrySelectionChange(obj) {
      this.showLoader = true;
      this.selectedCountry = obj;
      this.cardService.esimPackages(obj.countryCode).subscribe(res => {
        this.showLoader = false;
        if(res.body) {
          this.showFreePlanCard = true;
          this.planData = res.body;
        } else {
          this.showFreePlanCard = false;
          this.planData = {};          
        }
      }, err => {
        this.showFreePlanCard = false;
        this.planData = {};
        this.toast.error(err.error.message);        
      })
    }
  
    placeOrder() {
      sessionStorage.setItem(ConstantsKey.ESIM_SELECTED_PLAN, JSON.stringify(this.planData));
      this.router.navigate(['/link-international-card']);
    }
   
    toggleView(): void {
      if(this.orderType == "BUY") {
        this.displayCount = this.displayCount === 14 ? this.countryItems.length : 14;
      } else if(this.orderType == "CLAIM") {
        this.displayCount = this.displayCount === 14 ? this.claimCoutryItems.length : 14;
      }

    }
  
    onDurationSelect() {
        //this.isDurationSelected = true; 
      this.findEsimPlan();
    }
  
    onImageClick(singleItem: any) {
      // this.selectedCountry = singleItem.title;
      this.isCountrySelected = true;
      if(this.orderType == "BUY") {
        this.selectedCountry = singleItem;
        this.selectedCountryIcon = singleItem.icon;
        this.showDropdown = true;
        this.isDurationSelected = false; 
        this.selectedDuration = null; 
      } else if(this.orderType == "CLAIM") {
        this.selectedCountry = singleItem;
        this.selectedCountryIcon = singleItem.icon;
        this.showDropdown = true;
        this.isDurationSelected = true;
        this.getFindFreePackge();

      }
      this.searchCountryName = this.selectedCountry["title"];

    }
  
    resetView() {
      this.showDropdown = false;
      this.isDurationSelected = false;
      this.selectedDuration = null;
      this.isCountrySelected = false;
    }
  
    toggleView1() {
      this.showDropdown = !this.showDropdown;
    }
      

  /* selectPlan() {
    this.selectedPlan;
    console.log(this.selectedPlan);
  } */

    goToESimForm() {
    console.log(this.selectedPlan);
    if(this.isDurationSelected) {
      if(this.selectedPlan) {
        let currentSelectedPlan = this.eSimPackeges.filter(singlePack => singlePack.id = this.selectedPlan);
        console.log(currentSelectedPlan);
        sessionStorage.setItem(ConstantsKey.SELECTED_ESIM, JSON.stringify(currentSelectedPlan[0]));
        sessionStorage.setItem(ConstantsKey.SELECTED_ESIM_REQUEST, JSON.stringify({"countryCode":this.selectedCountry["countryCode"],"duration":this.selectedDuration}));        
        this.router.navigate(['/esim-form']);
      } else {
        this.toast.error("Please select eSIM plan");        
      }  
    } else {
      this.toast.error("Please select Trip Duration");
    }

  }
  searchForCountry(searchCountry) {
    if(searchCountry != "") {
      if(this.orderType == "BUY") {
        this.filteredCountry = this.countryItems.filter(obj => obj.title.toLowerCase().includes(searchCountry.toLowerCase()));
      } else if(this.orderType == "CLAIM") {
        this.filteredCountry = this.claimCoutryItems.filter(obj => obj.title.toLowerCase().includes(searchCountry.toLowerCase()));
      }
    } else {
        this.filteredCountry = this.orderType == "BUY" ? this.countryItems : this.claimCoutryItems;
    }

  }

  findEsimPlan() {
    this.showLoader = true;
    console.log(this.selectedDuration, this.selectedCountry );
    this.cardService.findPlanForESIM(this.selectedCountry["countryCode"],this.selectedDuration).subscribe(resp => {
      this.showLoader = false;
      console.log("RESP == >> ",resp.body);
      this.isDurationSelected = true; 
      let respData = resp.body;
      this.eSimPackeges = respData["data"];
    }, err => {
      this.showLoader = false;
      this.isDurationSelected = true; 
      this.toast.error(err.error.message);        
    });
  }

  clearCountrySelection() {
    this.resetView();
    this.searchCountryName = "";
    this.isCountrySelected = false;
    this.filteredCountry = this.countryItems;
  }

  getFindFreePackge() {
    this.cardService.esimPackages(this.selectedCountry["countryCode"]).subscribe(res => {
      console.log(res);
      this.eSimPackeges = res.body;
      //this.selectedDuration = this.eSimPackeges["days"];
    }, err => {
      this.toast.error(err.error.message); 
    });
  }
  opendevicesModal() {
    this.modalService.open(this.devicesModal, { size: 'sm', windowClass: 'centered-modal' });
  }

}
